import React from "react";
import Home from "./segments/Home";
import Login from "./segments/Login";
import Loading from "./components/Loading";
import Cursor from "./components/Cursor";
import { initDrive } from "./api/gapi";
import styles from "./styles";
import "antd/dist/antd.css";

import API from "./api/requests";
const { signUpUser, signInUser, signOutUser, updateUserInfo } = API;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.host = "https://54.67.14.28:8081";
    this.state = {
      userId: null,
      userInfo: {},
      errMsgs: {},
      loading: true,
      localMode: false,
    };
    this.setLoginErrMsg = this.setLoginErrMsg.bind(this);
    this.setLoading = this.setLoading.bind(this);
    this.setLocalMode = this.setLocalMode.bind(this);
  }

  setLoginErrMsg(errMsg) {
    this.setState((state) => ({
      ...state,
      errMsgs: {
        ...state.errMsgs,
        login: errMsg,
      },
    }));
  }

  setLoading(loading) {
    this.setState((state) => ({
      ...state,
      loading,
    }));
  }

  setLocalMode(localMode) {
    this.setState((state) => ({
      ...state,
      localMode,
    }));
  }

  componentDidMount() {
    signInUser(null, null, true, this);
    setTimeout(() => initDrive(), 3000);
  }

  render() {
    if (this.state.loading) return <Loading />;
    else if (this.state.userId || this.state.localMode)
      return (
        <div style={styles.fullScreenContainer}>
          <Cursor />
          <Home
            userId={this.state.userId}
            userInfo={this.state.userInfo}
            localMode={this.state.localMode}
            updateUserInfo={(info) => {
              if (this.state.localMode)
                this.setState((state) => ({
                  ...state,
                  userInfo: info,
                }));
              else {
                updateUserInfo(info, this);
              }
            }}
            host={this.host}
            signOutUser={() => signOutUser(this)}
          />
        </div>
      );
    else {
      return (
        <div style={styles.fullScreenContainer}>
          <Cursor />
          <Loading style={{ backgroundColor: "transparent", height: "50%" }} />
          <Login
            signInUser={(email, password, initial = false) =>
              signInUser(email, password, initial, this)
            }
            signUpUser={(userName, email, password, userType) =>
              signUpUser(userName, email, password, userType, this)
            }
            setLocalMode={this.setLocalMode}
            errMsg={this.state.errMsgs.login}
            setErrMsg={this.state.setLoginErrMsg}
          />
        </div>
      );
    }
  }
}

export default App;
